<template>
  <div class="form-group">
    <h3 class="text-center">{{ title }}</h3>
    <div class="slider-wrapper w-100">
      <slider :options="{ slidesToScroll: 3 }">
        <slideritem
          v-for="(option, index) in options"
          :key="index"
          :style="{ width: '20%', padding: '10px', 'padding-bottom': '20px' }"
        >
          <div
            class="card h-100 w-100"
            :class="chosen_options.includes(option) ? 'border-success' : ''"
            role="button"
            @click="toggle(option)"
          >
            <div class="card-body" v-if="logo">
              <div class="logo" v-if="logo" :style="{ 'background-image': 'url(' + logo(option) + ')' }"></div>
            </div>
            <div class="mt-auto text-center slide-item">
              <span v-if="name">{{ name(option) }}</span>
              <span v-else>{{ index }}</span>
            </div>
          </div>
        </slideritem>
      </slider>
    </div>
  </div>
</template>
<script>
// TODO: Implement using vue-slick-carousel instead. Mads have used this in cost sheets create.
import { slider, slideritem } from 'vue-concise-slider';

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    logo: {
      type: Function,
      required: false,
      default: null
    },
    name: {
      type: Function,
      required: false,
      default: null
    }
  },
  components: {
    slider,
    slideritem
  },
  computed: {
    chosen_options() {
      return this.value;
    }
  },
  methods: {
    toggle(object) {
      if (this.chosen_options.includes(object)) {
        this.chosen_options.splice(this.chosen_options.indexOf(object), 1);
      } else {
        this.chosen_options.push(object);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.slider-wrapper >>> .slider-pagination-bullet-active {
  background-color: black;
  background-color: var(--primary);
}
.slider-wrapper >>> .slider-pagination-bullets {
  bottom: -5px;
}
.logo {
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.slide-item {
  font-size: 0.9rem;
  color: #343a40;
}
</style>
